import { useCallback } from 'react';

import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';

export function useCopyMemoContentToClipboard() {
  const { showFeedback } = useFeedback();
  const [copyToClipboard] = useCopyToClipboard();

  return useCallback(
    (memoContent?: string | null) => {
      if (!memoContent) {
        showFeedback('No memo content found', {
          variant: 'info-low',
        });
        return false;
      }

      copyToClipboard(
        memoContent,
        () => {
          showFeedback('Memo copied to clipboard', {
            variant: 'success',
          });
        },
        () => {
          showFeedback('Failed to copy to clipboard');
        }
      );

      return true;
    },
    [copyToClipboard, showFeedback]
  );
}
